import SharedEpics from './shared/allEpics'
import UserEpics from './user/allEpics' // Export Defaults - Used Across All Apps ( base epics )

export default [...SharedEpics, ...UserEpics]